module.exports = __webpack_public_path__ + "static/media/banner_1.cd1dedc8.jpg";